import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function PhotosIndex() {
  const [albums, setAlbums] = useState([]);
  const [form, setForm] = useState({ id: "", name: "" });
  const nav = useNavigate();
  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  async function load() {
    const r = await fetch("/api/albums", { headers });
    const data = await r.json();
    setAlbums(Array.isArray(data) ? data : []);
  }

  useEffect(() => { load(); }, []);

  async function create(e) {
    e.preventDefault();
    if (!form.id || !form.name) return;
    await fetch("/api/albums", { method: "POST", headers, body: JSON.stringify(form) });
    await load();
    nav(`/photos/${form.id}`);
  }

  return (
    <div className="container" style={{ maxWidth: 1200, margin: "0 auto", padding: 16 }}>
      <h2>Álbuns</h2>

      <form onSubmit={create} style={{ display: "flex", gap: 8, margin: "12px 0" }}>
        <input
          placeholder="ID do álbum (slug)"
          value={form.id}
          onChange={(e) => setForm((s) => ({ ...s, id: e.target.value.trim() }))}
        />
        <input
          placeholder="Nome do álbum"
          value={form.name}
          onChange={(e) => setForm((s) => ({ ...s, name: e.target.value }))}
        />
        <button type="submit">Criar</button>
      </form>

      <ul style={{ paddingLeft: 16 }}>
        {albums.map((a) => (
          <li key={a.id} style={{ margin: "6px 0" }}>
            <Link to={`/photos/${a.id}`}>{a.name}</Link>
            <small style={{ marginLeft: 8, color: "#666" }}>({a.photos} fotos)</small>
          </li>
        ))}
        {albums.length === 0 && <li>Nenhum álbum ainda.</li>}
      </ul>
    </div>
  );
}
